import { render, staticRenderFns } from "./TotalsSidebar.vue?vue&type=template&id=31bc41cc&scoped=true&"
import script from "./TotalsSidebar.vue?vue&type=script&lang=js&"
export * from "./TotalsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TotalsSidebar.vue?vue&type=style&index=0&id=31bc41cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc41cc",
  null
  
)

export default component.exports